import getters from './getters'
import state from './state'
import mutations from './mutations'
import * as actions from './actions'

const store = {
  state,
  actions,
  getters,
  mutations,
  namespaced: true
}

export { store }
export default store
